module.exports = __webpack_public_path__ + "static/media/racoon.cb45bbfa.svg";